import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const CoreAPI = {
	// TODO: the function/request name is confusing, it looks like fetching data for client site
	getClientCoreErrorEntries: (request: ClientCoreErrorEntriesRequest) => {
		return axios
			.get(`${apiUrl}/core/${request.coreTestResultId}/excelerate`)
			.then((response) => response.data as CoreErrorEntryDTO[]);
	},

	getClientCoreErrorReportEntries: (request: ClientCoreErrorEntriesReportRequest) => {
		return axios
			.get(`${apiUrl}/core/${request.coreTestResultId}/excelerate/report`)
			.then((response) => response.data as CoreErrorEntryDTO[]);
	},

	// client site methods
	getCoreTest: (request: GetClientSiteCoreTestResultRequest) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/clients/${request.clientId}/core-results/${request.coreTestId}`
			)
			.then((response) => response.data as CoreTestResultDTO);
	},
	upsertCoreTest: (request: UpsertCoreTestResultRequest) => {
		return axios
			.post(`${clientApiUrl}/clients/${request.clientId}/core-results`, request)
			.then((response) => response.data as CoreTestResultDTO);
	},
	getClientSiteClientCoreErrorEntries: (
		request: ClientSiteClientCoreErrorEntriesRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/core/${request.coreTestResultId}/excelerate`
			)
			.then((response) => response.data as CoreErrorEntryDTO[]);
	},
	getClientSiteClientCoreErrorReportEntries: (
		request: ClientSiteClientCoreErrorEntriesReportRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/core/${request.coreTestResultId}/excelerate/report`
			)
			.then((response) => response.data as CoreErrorEntryDTO[]);
	},
	getClientSiteCoreErrorEntryListItems: (
		request: ClientSiteCoreErrorEntryListItemsRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/core/${request.id}/core-error-entry-listitems`
			)
			.then((response) => response.data as CoreErrorEntryListItemDTO[]);
	},
	upsertClientSiteCoreErrorEntry: (
		request: UpsertClientSiteCoreErrorEntryRequest
	) => {
		return axios
			.post(
				`${clientApiUrl}/datasets/${request.datasetId}/core/${request.coreTestResultId}/excelerate`,
				request
			)
			.then((response) => response.data as CoreErrorEntryDTO[]);
	},
	checkExistingIncompleteCoreTest: (
		request: CheckExistingIncompleteCoreTestRequest
	) => {
		return axios
			.get(`${clientApiUrl}/clients/${request.clientId}/existing-incomplete`)
			.then((response) => response.data as boolean);
	},
	deleteCoreTestResult: (request: DeleteCoreTestResultRequest) => {
		return axios
			.delete(
				`${clientApiUrl}/clients/${request.clientId}/core-results/${request.coreTestId}`
			)
			.then((response) => response.data);
	},
	getClientsiteCourses: (req: ClientSiteDatasetCoursesRequest) => {
		return axios
			.get(
				`${clientApiUrl}/organizations/${req.organizationId}/datasets/${req.datasetId}/courses`
			)
			.then((res) => res.data as CourseWithLocationNameDTO[]);
	},
	checkActiveCoursesAndLocationsForCoreTest: ({
		clientId,
		organizationId,
		datasetId,
	}: CheckActiveCoursesAndLocationsForCoreRequest) => {
		return axios
			.get(`${clientApiUrl}/clients/${clientId}/check-core`, {
				params: { organizationId, datasetId },
			})
			.then((res) => res.data as boolean);
	},
	getGoogleMap: ({
		coreTestResultId,
		routeColor,
		errorColor,
		hazardousErrorColor
	}: GoogleMapRequest) => {
		return axios
			.get(`${clientApiUrl}/MapRequest/${coreTestResultId}`, {
				params: { coreTestResultId, routeColor, errorColor, hazardousErrorColor },
			})
			.then((res) => {
				if (res.data.length > 0) {
					const byteCharacters = atob(res.data);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
					const image = new Blob([byteArray], { type: 'image/jpeg' });
					const imageURL = URL.createObjectURL(image);
					return imageURL as string;
				}
				return "";
			});
	},
};

export default CoreAPI;
